import StarsIcon from '../../../assets/icons/stars.svg?react'

const AdvisorAvatar = () => {
  return (
    <div className='rounded-full border-solid border p-[10px] border-deep-green'>
      <StarsIcon className='stroke-deep-green' />
    </div>
  )
}

export default AdvisorAvatar
